import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 20H8C6.9 20 6 19.1 6 18V12.1C6 11.53 6.44 11.06 7 11V9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9H15C15 7.35 13.65 6 12 6C10.35 6 9 7.35 9 9V11H16.9C17.51 11 18 11.49 18 12.1V18C18 19.1 17.1 20 16 20ZM8 13V18H16V13H8Z" fill={ fill || 'currentColor' } />
    </svg>
);
